import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SpreadProfileAction } from '../spreadProfile.action';

type IDependencies = IClientApiDependencySegment;

export const removeSpreadProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SpreadProfileAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deleteSpreadProfile({ id: params.id }).pipe(
      mergeMap(() => {
        return [
          SpreadProfileAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          SpreadProfileAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
